import React from 'react';
import { Table, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const PriceList = () => {
  const { t } = useTranslation();

  // Tablica danych - łatwe dodawanie nowych pozycji
  const priceItems = [
    {
      name: 'products.priceList.items.documentProcessing',
      cost: 'products.priceList.items.oneCredit',
      actionLink: '/medical-documents/create',
    },
    {
      name: 'products.priceList.items.medicalReport',
      cost: 'products.priceList.items.oneCredit',
      actionLink: '/medical-documents',
    },
    {
      name: 'products.priceList.items.healthReport',
      cost: 'products.priceList.items.twoCredits',
      actionLink: '/health-reports',
    },
    {
      name: 'products.priceList.items.moleClassification',
      cost: 'products.priceList.items.oneCredit',
      actionLink: '/skin-moles',
    },
  ];

  return (
    <div className='mt-4'>
      <h3 className='text-center mb-4'>{t('products.priceList.title')}</h3>
      <Table striped bordered hover responsive>
        <thead>
          <tr>
            <th>{t('products.priceList.columns.name')}</th>
            <th>{t('products.priceList.columns.cost')}</th>
            <th>{t('products.priceList.columns.actions')}</th>
          </tr>
        </thead>
        <tbody>
          {priceItems.map((item, index) => (
            <tr key={index}>
              <td>{t(item.name)}</td>
              <td>{t(item.cost)}</td>
              <td>
                <Button
                  as={Link}
                  to={item.actionLink}
                  variant='logo-green'
                  size='sm'
                >
                  {t('products.priceList.actions.go')}
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
};

export default PriceList;
